// Period helpers shared by the dispatcher sections (KOP-39 spec §5.1). Pure: no Vue, no axios.
import { todayIso } from './format';

const ISO_DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

function parts(iso) {
  const m = ISO_DATE_RE.exec(String(iso == null ? '' : iso));
  return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : null;
}

export function isIsoDate(iso) {
  if (typeof iso !== 'string') return false;
  const p = parts(iso);
  if (!p) return false;
  const d = new Date(p[0], p[1] - 1, p[2]);
  return d.getFullYear() === p[0] && d.getMonth() === p[1] - 1 && d.getDate() === p[2];
}

export function shiftIso(iso, days) {
  const [y, m, d] = parts(iso);
  return todayIso(new Date(y, m - 1, d + days));
}

export function isValidPeriod(period) {
  return !!period && isIsoDate(period.from) && isIsoDate(period.to) && period.from <= period.to;
}

export function samePeriod(a, b) {
  return !!a && !!b && a.from === b.from && a.to === b.to;
}

/** Valid from/to from the query (swapped values are ordered); otherwise `fallback`. */
export function readPeriod(query, fallback) {
  const q = query || {};
  if (!isIsoDate(q.from) || !isIsoDate(q.to)) return fallback;
  return q.from <= q.to ? { from: q.from, to: q.to } : { from: q.to, to: q.from };
}

export function periodQuery(period) {
  return { from: period.from, to: period.to };
}
